export default __webpack_public_path__ + "images/c6739374aa482496f8e0cb5acc4ac646-science.jpg";